import ModulesTableCard from "./ModulesTableCard";

export default ModulesTableCard;